import { render, staticRenderFns } from "./PassepartoutSmallLogo.vue?vue&type=template&id=507d9e69"
import script from "./PassepartoutSmallLogo.vue?vue&type=script&lang=js"
export * from "./PassepartoutSmallLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports